import * as Immutable from 'immutable';
import * as React from 'react';
import ModuleAddContainer from '../../ModuleList/_containers/ModuleAddContainer';
import { Categories } from '../../Module/_config/ModuleInfo';
import { Trans } from 'react-i18next';
import PreviewFabricButtonContainer from '../_containers/PreviewFabricButtonContainer';
import LayersButtonContainer from '../_containers/LayersButtonContainer';

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export type Props = {
	withBottomBorder?: boolean
}

export default class ZoomIndicator extends React.Component<Props> {
	render = () => {
		return <>
			<div className={"action-buttons" + (this.props.withBottomBorder ? " with-border" : "" )}>
				<PreviewFabricButtonContainer />
				<div className="action-buttons__modules">
					<ModuleAddContainer iconName="images"  category={Categories.Images}><T>IMAGES</T></ModuleAddContainer>
					<ModuleAddContainer iconName="shapes"  category={Categories.Shapes}><T>SHAPES</T></ModuleAddContainer>
					<ModuleAddContainer iconName="effects"  category={Categories.Effects}><T>EFFECTS</T></ModuleAddContainer>
					<ModuleAddContainer iconName="repeats"  category={Categories.Transforms}><T>REPEATS</T></ModuleAddContainer>
				</div>
				<LayersButtonContainer />
			</div>
		</>
	}
}